import React, { useEffect, useState } from "react";
import { BiVideoPlus } from "react-icons/bi";
import Person from "../../assets/newicons/inperson.svg";
import view from "../../assets/newicons/eye1.svg";
import AppointmentService from "../../Services/AppointmentService";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { APP_ROUTES } from "../../PageRouting/pageRoutes";
import { notifyPatient } from "../../config/firebase";
import { useDispatch, useSelector } from "react-redux";
import { Avatar, Spin } from "antd";
import { setSelectedAppt } from "../../Redux/actions/appointmentActions";

const UpcomingAppointments = ({ profile, profileImage }) => {
  const [loading, setLoading] = useState(true);
  const [appointmentData, setAppointmentData] = useState([]);
  const [formattedDates, setFormattedDates] = useState([]);
  const { patientData } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (patientData?.patientId) {
      Appoinment(patientData.patientId);
    }
  }, [patientData]);

  const getMonthStartEndDates = () => {
    const now = new Date();
    const futureDate = new Date();
    futureDate.setDate(now.getDate() + 30);

    return {
      fromDate: now.toLocaleDateString("en-US"),
      toDate: futureDate.toLocaleDateString("en-US"),
    };
  };

  const Appoinment = (patCode) => {
    setLoading(true);
    const { fromDate, toDate } = getMonthStartEndDates();

    let payload = {
      patientId: patCode,
      status: 1,
      fromDate,
      toDate,
    };
    if (!patientData?.parentPatientId) {
      payload.includeFamilyMember = "Y";
    }
    AppointmentService.getPatientAppointment(payload)
      .then((result) => {
        setAppointmentData(result.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const convertUTCDate = (date, format = "MM/DD/YYYY") => {
    const d = new Date();
    if (!format) {
      date = new Date(
        moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
        " " +
        d.getHours() +
        ":" +
        d.getMinutes()
      );
    }
    return moment(new Date(date)).utc().format(format);
  };

  const handleJoinClick = async (details) => {
    const currentDate = new Date();
    const formattedDate = convertUTCDate(currentDate, "YYYY-MM-DD HH:mm:ss");
    if (details.serviceCode !== "APPT_VIDEO") {
      return;
    }
    try {
      let payload1 = {
        patientName: details?.patientName,
        personType: "Patient",
        appointmentId: details.appointmentId,
        modifiedBy: details.userId,
        modifiedDate: formattedDate,
        patientId: details.patientId,
        queueStatus: "Y",
        userId: details.userId,
        joiningDateTime: formattedDate,
      };
      await AppointmentService.callQueueUpdate(payload1);
      await notifyPatient(
        details.patientId,
        details.appointmentId,
        details.patientName,
        details.userId
      );
      dispatch(setSelectedAppt(details));
      localStorage.setItem("selectedAppt", JSON.stringify(details));
      navigate(APP_ROUTES.VIDEOCALL, {
        state: { selectedAppDetails: details },
      });
    } catch (error) {
      console.error("Error updating appointment or queue:", error);
    }
  };

  useEffect(() => {
    if (!appointmentData || !Array.isArray(appointmentData)) {
      console.error("Invalid appointment data format");
      return;
    }

    const formatAppointmentDates = () =>
      appointmentData.map((appointment) => {
        try {
          if (!appointment.appointmentDate || !appointment.startTime) {
            console.warn("Missing date/time in appointment:", appointment.id);
            return "Invalid appointment time";
          }

          const [month, day, year] = appointment.appointmentDate.split("/");
          const date = new Date(year, month - 1, day);
          if (isNaN(date)) {
            throw new Error(`Invalid date for appointment ${appointment.id}`);
          }

          const formattedDate = date.toLocaleDateString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric",
          });

          return `${formattedDate} ${appointment.startTime}`;
        } catch (error) {
          console.error(
            `Error processing appointment ${appointment.id}:`,
            error
          );
          return "Invalid date format";
        }
      });

    setFormattedDates(formatAppointmentDates());
  }, [appointmentData]);

  const handleClick = () => {
    navigate("/myappointments");
  };

  return (
    <div
      className="p-4 bg-white rounded-xl shadow-md border h-80 overflow-y-scroll"
      id="unique-scroll"
    >
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-sm font-semibold text-[#D8383A] font-sans">
          Upcoming Appointments
        </h2>
        <div className="flex items-center gap-3">
          <img
            onClick={handleClick}
            src={view}
            alt="View"
            className="w-7 h-7 cursor-pointer"
          />
        </div>
      </div>

      <div className="max-h-[300px] overflow-y-auto scrollWidth pr-1">
        {loading ? (
          <div className="flex justify-center items-center py-6">
            <Spin />{" "}
          </div>
        ) : appointmentData && appointmentData.length === 0 ? (
          <div className="text-center text-sm text-gray-500 py-6">
            No appointments today
          </div>
        ) : (
          appointmentData &&
          appointmentData.map((appt, i) => {
            const statusText =
              appt.status === 1
                ? "Pending"
                : appt.status === 2
                  ? "Completed"
                  : appt.status === 9
                    ? "Cancelled"
                    : "";
            const canJoin = ![0, 2, 9].includes(appt.status);

            return (
              <div key={i} className="bg-white shadow rounded-xl border mb-4">
                <div className="flex sm:flex-col sm:items-start items-center justify-between p-3 border-b">
                  <span className="text-xs bg-[#FFD5D5] text-[#333333] px-3 py-1 rounded-md font-semibold">
                    {formattedDates[i]}
                  </span>
                  {appt?.serviceCode == "APPT_VIDEO" && (
                    <button
                      className={`flex items-center gap-1 text-white px-3 py-1 rounded-md text-xs font-medium ${canJoin
                        ? "bg-[#189FAA] "
                        : "bg-gray-400 cursor-not-allowed"
                        }`}
                      disabled={!canJoin}
                      onClick={() => handleJoinClick(appt)}
                    >
                      <BiVideoPlus className="w-4 h-4" />
                      Join call
                    </button>
                  )}
                </div>

                <div className="p-3 space-y-2">
                  <div className="flex items-center gap-2 relative">
                    <Avatar
                      size={32}
                      src={appt?.photoName ? process.env.REACT_APP_IMAGE_URL + appt?.photoName : null}
                      className="w-8 h-8 rounded-full bg-[#189FAA] text-white text-xs font-semibold flex items-center justify-center"
                    >
                      {!appt?.photoName && appt?.patientName?.charAt(0).toUpperCase()}
                    </Avatar>

                    <span className="text-xs font-medium font-sans text-[#333333]">
                      {appt.patientName}
                    </span>
                    {patientData.patientId !== appt.patientId && (
                      <span
                        title="Family Member Appointment"
                        className="absolute top-0 right-10 cursor-pointer bg-blue-500 text-white  text-sm px-2 rounded-full"
                      >
                        F
                      </span>
                    )}
                  </div>

                  <div className="text-xs font-medium font-sans text-[#333333]">
                    {appt.appointmentReason && (
                      <span className="text-xs font-medium font-sans text-[#828282]">
                        Reason:
                      </span>
                    )}
                    {appt.appointmentReason}
                  </div>

                  <div className="flex gap-5 pt-2 border-t">
                    <span className="flex items-center gap-2 text-xs font-medium font-sans text-[#333333]">
                      <span className="h-2 w-2 rounded-full bg-yellow-500"></span>
                      {statusText}
                    </span>
                    <span className="border-l-2 border"></span>
                    <span className="flex items-center gap-2 text-xs font-medium font-sans text-[#333333]">
                      <span className="font-semibold"> {appt?.userName} </span>
                      <img src={Person} alt="" className="w-6 h-7" />
                      {appt.serviceName}
                    </span>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default UpcomingAppointments;
